module.exports = __webpack_public_path__ + "img/其他设备-g.e47b8ba9.png";